export class LoanAgreementModel {
  quoteId: number;
  acknowledgement: any;
  ficaSightingAcknowledgement: any;

  creditLifeScriptBean: any;
  fmbRejectionLetterBean: any;

    loanChecklist: any;
    reportType: string;
    language: string;
}
